import { render, staticRenderFns } from "./BicForm.vue?vue&type=template&id=4671e059&"
import script from "./BicForm.vue?vue&type=script&lang=js&"
export * from "./BicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4671e059')) {
      api.createRecord('4671e059', component.options)
    } else {
      api.reload('4671e059', component.options)
    }
    module.hot.accept("./BicForm.vue?vue&type=template&id=4671e059&", function () {
      api.rerender('4671e059', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bic/BicForm.vue"
export default component.exports